<template>

    <div class="page-thumbnails" :class="{disabled: state !== 'ready'}" disabled="true">
        <div class="page-thumbnail" v-for="(customContractPage, index) in customContract.custom_contract_pages">
            <img
                :key="customContractPage.id"
                :src="customContractPage.image + '?token=' + getToken"
                @click="click(index)"
            />
            <div class="page-thumbnail-caption">
                <span
                    :class="{
                    'contains-signatures': customContractPage.has_signatures,
                    'active': value === customContractPage
                }"
                >
                    {{ index + 1 }}
                </span>
            </div>
        </div>
    </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "CustomContractPageSelect",
    components: {},
    computed: {
        ...mapGetters(['getToken'])
    },
    props: ['customContract', 'value', 'state'],
    methods: {
        click: function (index) {
            this.$emit('input', this.customContract.custom_contract_pages[index]);
        }
    }
}
</script>

<style scoped lang="scss">

div.disabled {
    pointer-events:none;
    opacity: 0.6;
}

</style>
